import { PropertyDashboard } from "../../components/dashboard/PropertyDashboard";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../assets/style/dashboardTheme";
import { useParams } from 'react-router-dom';

type PropertyParams = {
    readonly propertyId: string;
};

export const PropertyDashboardPage = () => {
    const { propertyId } = useParams<PropertyParams>();

    return (
        <ThemeProvider theme={theme}>
            <PropertyDashboard propertyId={propertyId} />
        </ThemeProvider>
    );
};